var styles = {"wrapper":"video-popup--wrapper","fadeIn":"video-popup--fade-in","closeButton":"video-popup--close-button","videoWrapper":"video-popup--video-wrapper"};

export { styles as default };
//# sourceMappingURL=VideoPopup.module.esm.js.map
